module.exports = __webpack_public_path__ + "3507da58.svg";